<template>
  <div class="donut-landing">
    <!-- SECTION 1: HERO -->
    <section class="hero-section">
      <div class="section-container hero-grid">
        <!-- Hero Left Info -->
        <div class="hero-info">
          <h1 class="hero-title">
            Продажи и заказы <br />
            <span class="accent-text">без лишних</span> переписок
          </h1>
          <p class="hero-subtitle">
            Клиенты сами просматривают каталог и делают заказ в Telegram или по ссылке из Instagram-профиля
          </p>
          <div class="hero-cta-group">
            <button
              class="btn-primary btn-lg"
              @click="openModal(MODAL.Audit)"
            >
              Поможем настроить
            </button>
            <a
              href="#examples"
              class="btn-secondary btn-lg"
              @click.prevent="scrollToTestimonials"
              >Посмотреть примеры</a
            >
          </div>
          <!-- Hero Trust Strip -->
          <div class="hero-trust">
            <div class="avatar-stack">
              <img
                v-for="(src, i) in trustLogos"
                :key="i"
                :src="src"
                alt="Магазин"
                class="avatar-img"
                :style="{ marginLeft: i > 0 ? '-10px' : '0px' }"
              />
            </div>
            <div class="trust-text">
              <div class="stars-svg-row">
                <svg
                  v-for="star in 5"
                  :key="star"
                  class="star-svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <polygon
                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                  />
                </svg>
              </div>
              <p class="trust-subtitle">Магазины рекомендуют</p>
            </div>
          </div>
        </div>

        <!-- Hero Right: Beauty Nail Banner with falling Telegram Notifications -->
        <div class="hero-visual beauty-nail-hero">
          <div class="bg-glow"></div>

          <!-- Banner Image Container -->
          <div class="banner-image-container">
            <BasePicture
              class="hero-banner-img"
              src="/images/ecommerce/hero/banner_shop.webp"
            />
          </div>

          <!-- Telegram Notification 1: Новая запись (order) -->
          <div class="tg-notif-card tg-notif-order">
            <div class="tg-notif-avatar-wrapper">
              <div class="tg-notif-avatar">
                <BasePicture
                  class="tg-notif-logo"
                  src="/logos/logo-black-new.svg"
                />
              </div>
              <div class="tg-notif-badge">
                <svg
                  class="tg-notif-plane"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M19.89 4.11a1.6 1.6 0 00-1.7-.22L3.62 10.15a1.61 1.61 0 00-.09 3l3.62 1.48a.79.79 0 00.82-.16l9-9a.4.4 0 01.57.57l-9 9a.79.79 0 00-.16.82l1.48 3.62a1.61 1.61 0 003-.09l6.26-14.57a1.6 1.6 0 00-.22-1.7z"
                  />
                </svg>
              </div>
            </div>
            <div class="tg-notif-content">
              <div class="tg-notif-header">
                <span class="tg-notif-title">Новый заказ</span>
                <span class="tg-notif-time">now</span>
              </div>
              <div class="tg-notif-body">5 товаров · 120 $ · Курьером</div>
            </div>
          </div>

          <!-- Telegram Notification 2: Запись подтверждена (reminder) -->
          <div class="tg-notif-card tg-notif-reminder">
            <div class="tg-notif-avatar-wrapper">
              <div class="tg-notif-avatar">
                <BasePicture
                  class="tg-notif-logo"
                  src="/logos/logo-black-new.svg"
                />
              </div>
              <div class="tg-notif-badge">
                <svg
                  class="tg-notif-plane"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M19.89 4.11a1.6 1.6 0 00-1.7-.22L3.62 10.15a1.61 1.61 0 00-.09 3l3.62 1.48a.79.79 0 00.82-.16l9-9a.4.4 0 01.57.57l-9 9a.79.79 0 00-.16.82l1.48 3.62a1.61 1.61 0 003-.09l6.26-14.57a1.6 1.6 0 00-.22-1.7z"
                  />
                </svg>
              </div>
            </div>
            <div class="tg-notif-content">
              <div class="tg-notif-header">
                <span class="tg-notif-title">Клиент ждет ответа</span>
                <span class="tg-notif-time">now</span>
              </div>
              <div class="tg-notif-body">Сергей · Telegram</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- SECTION 2: WHY DONUT (Taplink-inspired layout for mobile suitability) -->
    <section
      id="why-donut"
      class="why-section"
    >
      <div class="section-container">
        <div class="section-header align-center">
          <div class="section-badge">
            <svg
              class="badge-icon-svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              ></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line
                x1="12"
                y1="17"
                x2="12.01"
                y2="17"
              ></line>
            </svg>
          </div>
          <h2 class="section-title">Зачем вам нужен MyDonut?</h2>
        </div>

        <div class="why-grid-layout">
          <!-- Desktop Reasons Nav (Vertical column) -->
          <div class="why-slider-nav-desktop">
            <div
              v-for="(slide, index) in whySlides"
              :key="index"
              :class="['why-nav-item', { active: activeSlide === index }]"
              @click="setActiveSlide(index)"
            >
              <div class="why-nav-header-row">
                <span class="why-nav-num">0{{ index + 1 }}</span>
                <h4 class="why-nav-title">{{ slide.shortTitle }}</h4>
              </div>
              <div
                class="why-nav-body"
                v-if="activeSlide === index"
              >
                <p class="why-nav-text">{{ slide.text }}</p>
              </div>
            </div>
          </div>

          <!-- Mobile: Horizontal scrollable tabs (wrapped) -->
          <div class="why-tabs-row">
            <button
              v-for="(slide, index) in whySlides"
              :key="index"
              :class="['why-tab-btn', { active: activeSlide === index }]"
              @click="setActiveSlide(index)"
            >
              <span class="why-tab-text">{{ slide.shortTitle }}</span>
            </button>
          </div>

          <!-- Single Screenshot placeholder with slide transition -->
          <div
            class="why-image-wrapper-container"
            @touchstart="onTouchStart"
            @touchend="onTouchEnd"
          >
            <div class="why-screenshot-wrapper">
              <Transition
                name="why-fade"
                mode="out-in"
              >
                <BasePicture
                  :key="activeSlide"
                  class="why-screenshot-img"
                  :src="whySlides[activeSlide].image || '/images/beauty-nail/work/demo.png'"
                />
              </Transition>
            </div>
          </div>

          <!-- Dynamic active reason description centered -->
          <div class="why-active-desc-container">
            <p class="why-active-desc-text">{{ whySlides[activeSlide].text }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- SECTION 3: CLIENT STORIES -->
    <section
      id="testimonials"
      class="testimonials-section"
    >
      <div class="section-container">
        <div
          class="section-header align-center"
          style="align-items: flex-start"
        >
          <div class="section-badge">
            <svg
              class="badge-icon-svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
              />
            </svg>
          </div>

          <div style="display: flex; flex-direction: column">
            <h2 class="section-title">Наши клиенты</h2>
            <p class="section-subtitle">Переходите в социальные сети и смотрите закрепленные ссылки</p>
          </div>
        </div>

        <div class="testimonials-grid">
          <div
            v-for="(t, idx) in testimonials"
            :key="idx"
            class="testimonial-card hover-lift shadow-sm"
          >
            <div class="testimonial-header">
              <div class="testimonial-profile">
                <div class="profile-img-container">
                  <img
                    :src="t.photo"
                    :alt="t.name"
                    class="profile-img"
                  />
                </div>
                <div class="profile-info">
                  <div class="profile-name">{{ t.name }}</div>
                  <div class="profile-role">{{ t.role }}</div>
                </div>
              </div>
              <div class="testimonial-social-actions">
                <a
                  v-if="t.instagram"
                  :href="t.instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="btn-social btn-instagram"
                >
                  <svg
                    class="social-logo-btn"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="5"
                      ry="5"
                    ></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line
                      x1="17.5"
                      y1="6.5"
                      x2="17.51"
                      y2="6.5"
                    ></line>
                  </svg>
                </a>
                <a
                  v-if="t.telegram"
                  :href="t.telegram"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="btn-social btn-telegram"
                >
                  <svg
                    class="social-logo-btn"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15.82-1.07 4.96-1.53 7.03-.2.87-.51 1.16-.83 1.19-.69.06-1.21-.46-1.88-.9-1.05-.68-1.64-1.11-2.66-1.78-1.18-.78-.41-1.21.26-1.9.17-.18 3.19-2.92 3.25-3.18.01-.03.01-.15-.06-.21-.07-.06-.18-.04-.25-.03-.1.02-1.7 1.08-4.81 3.18-.46.31-.87.47-1.24.46-.4-.01-1.17-.23-1.74-.42-.7-.23-1.26-.35-1.21-.74.03-.2.28-.41.77-.62 3.01-1.31 5.02-2.18 6.03-2.61 2.87-1.22 3.46-1.43 3.85-1.44.09 0 .28.02.4.12.1.08.13.2.14.29 0 .04-.01.18-.02.26z"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div class="testimonial-divider"></div>

            <div class="stars-svg-row sm">
              <svg
                v-for="star in 5"
                :key="star"
                class="star-svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                />
              </svg>
            </div>
            <div class="testimonial-heading">«{{ t.title }}»</div>
            <p class="testimonial-quote">“{{ t.quote }}”</p>
          </div>
        </div>
      </div>
    </section>

    <!-- SECTION 4: PRICING -->
    <section
      id="pricing"
      class="pricing-section"
    >
      <div class="section-container">
        <div class="section-header align-center">
          <div class="section-badge">
            <svg
              class="badge-icon-svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <rect
                x="2"
                y="4"
                width="20"
                height="16"
                rx="2"
                ry="2"
              ></rect>
              <line
                x1="12"
                y1="18"
                x2="12"
                y2="18"
              ></line>
              <line
                x1="2"
                y1="10"
                x2="22"
                y2="10"
              ></line>
            </svg>
          </div>
          <h2 class="section-title">Сколько стоит MyDonut?</h2>
        </div>

        <div class="pricing-card-wrapper">
          <!-- Centered Pricing Calculator -->
          <div class="pricing-calculator card shadow-sm">
            <!-- Left inputs column -->
            <div class="calc-inputs-column">
              <!-- Product grades selector -->
              <div class="product-grades-container">
                <div class="grades-header">
                  <span class="grades-title">Товары</span>
                  <span class="grades-active-value">{{ productTiers[productTierIndex].limit }}</span>
                </div>

                <div class="grades-timeline-wrapper">
                  <div class="grades-timeline-track">
                    <div
                      class="grades-timeline-progress"
                      :style="{ width: progressPercentage + '%' }"
                    ></div>
                  </div>

                  <div class="grades-points">
                    <div
                      v-for="(tier, idx) in productTiers"
                      :key="idx"
                      :class="[
                        'grade-point-wrapper',
                        { active: productTierIndex === idx, passed: idx <= productTierIndex },
                      ]"
                      @click="productTierIndex = idx"
                    >
                      <div class="grade-point-dot"></div>
                      <span class="grade-point-label">{{ tier.limit }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="calc-divider"></div>

              <!-- Billing Toggle Buttons (Only months and discounts shown) -->
              <div class="periods-scroll-row-mini">
                <button
                  v-for="period in periods"
                  :key="period.key"
                  :class="['period-rate-card-mini', { active: selectedPeriod === period.key }]"
                  @click="selectedPeriod = period.key"
                >
                  <span class="period-title-mini">{{ period.label }}</span>
                  <span
                    class="period-discount-badge-mini"
                    v-if="period.discount > 0"
                  >
                    -{{ period.discount }}%
                  </span>
                </button>
              </div>
            </div>

            <!-- Right totals column -->
            <div class="calc-totals-column">
              <!-- Promo Code Switcher -->
              <div class="promo-switch-box">
                <div class="promo-switch-label">
                  <span class="promo-switch-title">Скидка 15%</span>
                  <span class="promo-switch-desc">По промокоду START15 на первую оплату</span>
                </div>
                <label class="switch-control">
                  <input
                    type="checkbox"
                    v-model="isPromoApplied"
                  />
                  <span class="switch-slider"></span>
                </label>
              </div>

              <!-- Total Price Section -->
              <div class="total-price-wrapper">
                <div class="total-price">
                  <div class="total-price-section">
                    <div class="total-header">Итого к оплате:</div>
                    <div class="price-display-wrapper">
                      <div class="total-big-price">${{ totalToPay }}</div>
                      <div class="total-monthly-hint">
                        <span v-if="getSelectedPeriodMonths() > 1">(${{ finalMonthly }}/мес)</span>
                        <span v-else>/мес</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pricing-roi-callout animate-pulse-slow">
                  <span class="roi-strong-text">Окупается всего 1 заказом!</span>
                </div>
                <div
                  class="cta-buttons"
                  style="flex-direction: column; width: 100%"
                >
                  <button
                    class="btn-primary btn-lg"
                    @click="openModal(MODAL.Audit)"
                  >
                    Хочу помощь с настройкой
                  </button>
                  <button
                    class="btn-secondary btn-lg"
                    style="background-color: white"
                    @click="openModal(MODAL.AuthRegistration)"
                  >
                    Настрою сам
                  </button>
                </div>
                <div class="trust-item">
                  <span class="check-circle-icon">
                    <svg
                      viewBox="0 0 24 24"
                      width="8"
                      height="8"
                      stroke="currentColor"
                      stroke-width="4"
                      fill="none"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </span>
                  14 дней бесплатно
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="testimonials-section section-cases"
      id="examples"
    >
      <div class="section-container">
        <div class="section-header align-left">
          <div class="section-badge">
            <svg
              class="badge-icon-svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect
                x="2"
                y="7"
                width="20"
                height="14"
                rx="2"
                ry="2"
              />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
          </div>
          <div style="display: flex; flex-direction: column">
            <h2 class="section-title">Посмотрите демо</h2>
            <p class="section-subtitle">Откройте демо и оформите заказ</p>
          </div>
        </div>

        <BaseSlider
          allow-touch-move
          class="section-cases__slider"
          :navigation="{
            nextEl: `#cases-slider-button-next`,
            prevEl: `#cases-slider-button-previous`,
          }"
          :slides="SECTION_CARDS"
          slides-per-view="auto"
          :space-between="20"
          loop
        >
          <template #default="{ slide, index }">
            <div class="case-slide testimonial-card hover-lift shadow-sm">
              <BasePicture
                class="case-slide__image"
                :src="`/images/demo/${slide.image}`"
              />

              <div class="case-slide__wrapper">
                <div class="case-slide__header">
                  <span class="case-slide__badge"> {{ t("landing.cases.badge") }} #{{ index + 1 }} </span>

                  <h3 class="case-slide__title">
                    {{ slide.title }}
                  </h3>
                </div>

                <p class="case-slide__text">
                  {{ slide.description }}
                </p>

                <BaseLink
                  class="btn-secondary btn-sm case-slide__link"
                  :href="slide.href"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <BaseIcon2
                    id="icon-telegram-full"
                    color="var(--orange-1)"
                    height="20"
                    sprite="socials"
                    width="20"
                    style="margin-right: 4px"
                  />
                  {{ t("landing.cases.button.view") }}
                </BaseLink>
              </div>
            </div>
          </template>
        </BaseSlider>

        <div class="section-cases__navigation">
          <BaseButton2
            v-for="direction in ['previous', 'next']"
            :id="`cases-slider-button-${direction}`"
            :key="direction"
            class="section-cases__button"
            :class="direction"
          >
            <BaseIcon2
              id="icon-cap"
              class="section-cases__icon"
            />
          </BaseButton2>
        </div>
      </div>
    </section>

    <!-- SECTION 5: COMPARISON -->
    <section
      id="comparison"
      class="comparison-section"
    >
      <div class="section-container">
        <div class="section-header align-center">
          <div class="section-badge">
            <svg
              class="badge-icon-svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle
                cx="12"
                cy="8"
                r="7"
              ></circle>
              <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
            </svg>
          </div>
          <h2 class="section-title">Чем MyDonut лучше других сервисов?</h2>
        </div>

        <div class="table-scroll-container">
          <table class="comparison-table">
            <thead>
              <tr>
                <th class="table-param-header">Параметр</th>
                <th class="table-donut-header">
                  <div class="donut-header-content">
                    <span class="donut-title">MyDonut</span>
                  </div>
                </th>
                <th class="table-competitor-header">
                  <div class="comp-title">Другие сервисы</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, idx) in compRows"
                :key="idx"
              >
                <td>
                  <div class="cell-param">
                    <!-- Render custom SVG icon per parameter instead of emoji -->
                    <div class="param-icon-wrapper">
                      <svg
                        v-if="idx === 0"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="3"
                          width="20"
                          height="14"
                          rx="2"
                          ry="2"
                        />
                        <line
                          x1="8"
                          y1="21"
                          x2="16"
                          y2="21"
                        />
                        <line
                          x1="12"
                          y1="17"
                          x2="12"
                          y2="21"
                        />
                      </svg>
                      <svg
                        v-else-if="idx === 1"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="20"
                          height="16"
                          rx="2"
                          ry="2"
                        />
                        <line
                          x1="12"
                          y1="18"
                          x2="12"
                          y2="18"
                        />
                        <line
                          x1="2"
                          y1="10"
                          x2="22"
                          y2="10"
                        />
                      </svg>
                      <svg
                        v-else-if="idx === 2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <rect
                          x="5"
                          y="2"
                          width="14"
                          height="20"
                          rx="2"
                          ry="2"
                        />
                        <line
                          x1="12"
                          y1="18"
                          x2="12.01"
                          y2="18"
                        />
                      </svg>
                      <svg
                        v-else-if="idx === 3"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                      </svg>
                      <svg
                        v-else-if="idx === 4"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                      </svg>
                      <svg
                        v-else-if="idx === 5"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                        />
                        <path
                          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
                        />
                      </svg>
                    </div>
                    <span class="param-label">{{ row.label }}</span>
                  </div>
                </td>
                <td class="cell-donut">
                  <div class="badge-status-container">
                    <span :class="['table-badge', row.donut.type]">
                      <span class="table-badge-icon">
                        <svg
                          viewBox="0 0 24 24"
                          width="12"
                          height="12"
                          stroke="currentColor"
                          stroke-width="3"
                          fill="none"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      {{ row.donut.text }}
                    </span>
                  </div>
                </td>
                <td class="cell-competitor">
                  <div class="badge-status-container">
                    <span :class="['table-badge', row.rival.type]">
                      <span class="table-badge-icon">
                        <svg
                          v-if="row.rival.type === 'bad'"
                          viewBox="0 0 24 24"
                          width="12"
                          height="12"
                          stroke="currentColor"
                          stroke-width="3"
                          fill="none"
                        >
                          <line
                            x1="18"
                            y1="6"
                            x2="6"
                            y2="18"
                          ></line>
                          <line
                            x1="6"
                            y1="6"
                            x2="18"
                            y2="18"
                          ></line>
                        </svg>
                        <span
                          v-else
                          style="font-size: 20px; line-height: 14px"
                        >
                          *
                        </span>
                      </span>
                      {{ row.rival.text }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="comparison-footer">
          <p class="comparison-footnote">* Цена с учетом интеграций и полноценных функций</p>
        </div>
      </div>
    </section>

    <!-- SECTION 6: FINAL CTA -->
    <section class="final-cta-section">
      <div class="cta-bg-glow"></div>
      <div class="section-container cta-grid-layout">
        <!-- Left: Info -->
        <div class="cta-info-col">
          <h2 class="cta-headline">
            Проведём аудит, перенесём базу клиентов и <span class="accent-text">настроим всё за вас</span>
          </h2>
          <p class="cta-subtitle">Мы сами загрузим ваши товары, настроим категории и автоматизируем прием заказов.</p>
          <div class="cta-buttons">
            <button
              class="btn-primary btn-lg"
              @click="openModal(MODAL.Audit)"
            >
              Начать с нашей помощью
            </button>
            <button
              class="btn-secondary btn-lg"
              @click="openModal(MODAL.AuthRegistration)"
            >
              Начать самостоятельно
            </button>
          </div>
          <div class="cta-micro-trust">
            <div class="trust-item">
              <span class="check-circle-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="8"
                  height="8"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              14 дней бесплатно
            </div>
            <div class="trust-item">
              <span class="check-circle-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="8"
                  height="8"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              Отмена в любой момент
            </div>
          </div>
        </div>

        <!-- Right: Image Mockup -->
        <div class="cta-image-col">
          <BasePicture
            class="cta-mockup-img"
            src="/images/ecommerce/hero/application.webp"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n();
definePageMeta({
  layout: "landings",
});

const SECTION_CARDS = computed(() => [
  {
    description: "Спортивная одежда",
    href: "https://t.me/RunningFiveBot",
    image: "r5_logo.webp",
    reverse: true,
    title: "Running Five",
  },
  {
    description: "Украшения и акссесуары",
    href: "https://t.me/lunaraJewerlyBot",
    image: "lunara_logo.webp",
    reverse: true,
    title: "Lunara Jewelry",
  },
  {
    description: "Средства для волос",
    href: "https://t.me/DalyCityBot",
    image: "daly_logo.webp",
    reverse: true,
    title: "Daly City",
  },
]);

const trustLogos = [
  "/images/ecommerce/demo/joonies.jpg",
  "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=64&h=64&fit=crop&auto=format", // aesthetic cosmetics/skincare brand
  "/images/ecommerce/demo/vesnail.jpg",
  "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=64&h=64&fit=crop&auto=format", // aesthetic coffee shop/cafe
  "/images/ecommerce/demo/onejar.jpg",
];

const { openModal } = useModalStore();

useHead({
  meta: [
    {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no",
    },
  ],
});

useSeoMeta({
  title: "Продажи в мессенджерах без лишних переписок",
  description:
    "Клиенты сами делают заказ и получают уведомления в Telegram или по ссылке из Instagram-профиля. Автоматизируем прием заказов и помогаем перенести ваши товары в социальные сети.",
});

// SECTION 2: WHY DONUT STATE
const activeSlide = ref(0);
let slideInterval: any = null;

const startSlideTimer = () => {
  stopSlideTimer();
  slideInterval = setInterval(() => {
    activeSlide.value = (activeSlide.value + 1) % whySlides.length;
  }, 7000);
};

const stopSlideTimer = () => {
  if (slideInterval) {
    clearInterval(slideInterval);
    slideInterval = null;
  }
};

const setActiveSlide = (index: number) => {
  activeSlide.value = index;
  startSlideTimer();
};

const scrollToTestimonials = () => {
  const target = document.getElementById("examples");
  if (!target) return;

  const offset = 85;
  const mainScrollContainer = document.querySelector(".app__main") as HTMLElement | null;

  // Detect if .app__main is actually the scroll container on desktop
  const isMainScrollable =
    mainScrollContainer &&
    mainScrollContainer.scrollHeight > mainScrollContainer.clientHeight &&
    window.innerWidth >= 769;

  if (isMainScrollable && mainScrollContainer) {
    const containerRect = mainScrollContainer.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const targetPosition = targetRect.top + mainScrollContainer.scrollTop - containerRect.top - offset;
    mainScrollContainer.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  } else {
    const targetRect = target.getBoundingClientRect();
    const targetPosition = targetRect.top + window.pageYOffset - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  }
};

onMounted(() => {
  startSlideTimer();

  // Prevent pinch-to-zoom and double-tap zoom on mobile devices
  document.addEventListener("gesturestart", preventZoom);
  document.addEventListener("touchmove", preventTouchMoveZoom, { passive: false });
  document.addEventListener("touchend", preventDoubleTapZoom, false);
});

onUnmounted(() => {
  stopSlideTimer();

  // Clean up zoom prevention listeners
  document.removeEventListener("gesturestart", preventZoom);
  document.removeEventListener("touchmove", preventTouchMoveZoom);
  document.removeEventListener("touchend", preventDoubleTapZoom);
});

const preventZoom = (e: Event) => {
  e.preventDefault();
};

const preventTouchMoveZoom = (e: TouchEvent) => {
  if ((e as any).scale !== undefined && (e as any).scale !== 1) {
    e.preventDefault();
  } else if (e.touches.length > 1) {
    e.preventDefault();
  }
};

let lastTouchEnd = 0;
const preventDoubleTapZoom = (e: TouchEvent) => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    e.preventDefault();
  }
  lastTouchEnd = now;
};

// Touch swiping handlers
const touchStartX = ref(0);
const onTouchStart = (e: TouchEvent) => {
  touchStartX.value = e.touches[0].clientX;
};
const onTouchEnd = (e: TouchEvent) => {
  const touchEndX = e.changedTouches[0].clientX;
  const diffX = touchEndX - touchStartX.value;
  // Threshold of 50px
  if (Math.abs(diffX) > 50) {
    if (diffX < 0) {
      // Swipe left -> Next slide
      setActiveSlide((activeSlide.value + 1) % whySlides.length);
    } else {
      // Swipe right -> Previous slide
      setActiveSlide((activeSlide.value - 1 + whySlides.length) % whySlides.length);
    }
  }
};

const whySlides = [
  {
    shortTitle: "Уменьшить переписки в чате 💬",
    text: "Клиент смотрит каталог, видит наличие и делает заказ",
    image: "/images/ecommerce/work/pain-1.webp",
  },
  {
    shortTitle: "Увеличить повторные заказы ✍️️️",
    text: "Клиенты получают бонусы за заказы и рассылки об акциях",
    image: "/images/ecommerce/work/pain-2.webp",
  },
  {
    shortTitle: "Настроить продажи в Telegram 🛍️",
    text: "Продажи там, где сидит клиент без лишних переходов на сайт",
    image: "/images/ecommerce/work/pain-3.webp",
  },
  {
    shortTitle: "Не терять заказы в чатах 📌",
    text: "Единый чат с клиентом - все контакты сохраняются в вашей базе",
    image: "/images/ecommerce/work/pain-4.webp",
  },
  {
    shortTitle: "Не переплачивать за CRM 💸",
    text: "Всё включено в тариф и управляется с телефона — без сложных настроек и интеграций",
    image: "/images/ecommerce/work/pain-5.webp",
  },
  {
    shortTitle: "Не терять историю клиентов 👤",
    text: "Вся история общения, контакты и заказы клиента хранятся в одной карточке.",
    image: "/images/ecommerce/work/pain-6.webp",
  },
];

// SECTION 3: TESTIMONIALS
const testimonials = [
  {
    photo: "/images/ecommerce/demo/onejar.jpg",
    name: "OneJarPlease",
    role: "Вкусная домашняя еда в банках",
    instagram: "https://www.instagram.com/onejarplease",
    telegram: "https://t.me/onejarplsbot",
    title: "Заказы без долгих переписок",
    quote:
      "Раньше с клиентами уходили часы на переписку — адрес, оплата, детали заказа. Теперь всё это делает сам бот с приложением",
  },
  {
    photo: "/images/ecommerce/demo/joonies.jpg",
    name: "Joonies",
    role: "Подгузники, пелёнки, салфетки и товары для мам",
    instagram: "https://www.instagram.com/joonies_georgia/",
    telegram: "https://t.me/jooniesGeorgiaBot",
    title: "Дешевле и легкий переезд",
    quote:
      "Прошлый сервис дорогой и совсем не гибкий. А главное — нам помогли перенести всё, сами бы откладывали это месяцами",
  },
  {
    photo: "/images/ecommerce/demo/vesnail.jpg",
    name: "Vesnail Georgia",
    role: "Товары для маникюра",
    instagram: "https://www.instagram.com/_vesnail_georgia.official/",
    telegram: "https://t.me/vesnail_georgia_bot",
    title: "Продажи и клиенты в одном месте",
    quote: "Раньше продажи были разбросаны по разным площадкам. Здесь всё собрано — и управляем прямо с телефона",
  },
];

// SECTION 4: PRICING CALCULATOR STATE
const branches = ref(1);
const productTierIndex = ref(0);
const isPromoApplied = ref(true);
const progressPercentage = computed(() => {
  return (productTierIndex.value / (productTiers.length - 1)) * 100;
});

const basePrice = 8;
const branchPrice = 3;
const productTiers = [
  { limit: "30", price: 4 },
  { limit: "60", price: 6 },
  { limit: "100", price: 8 },
  { limit: "200", price: 15 },
  { limit: "500", price: 25 },
  { limit: "1000", price: 40 },
];

const periods = [
  { key: "monthly", label: "1 мес", months: 1, discount: 0 },
  { key: "three_months", label: "3 мес", months: 3, discount: 5 },
  { key: "six_months", label: "6 мес", months: 6, discount: 10 },
  { key: "yearly", label: "1 год", months: 12, discount: 20 },
];

const selectedPeriod = ref("monthly");
const getSelectedPeriodMonths = () => {
  const p = periods.find((p) => p.key === selectedPeriod.value);
  return p ? p.months : 1;
};

const getCalculatedMonthly = (discountPercent: number) => {
  const baseVal = basePrice + branches.value * branchPrice + productTiers[productTierIndex.value].price;
  const periodPrice = baseVal * (1 - discountPercent);
  const promoPrice = periodPrice * (1 - (isPromoApplied.value ? 0.15 : 0));
  return promoPrice.toFixed(2);
};
const finalMonthly = computed(() => {
  const p = periods.find((p) => p.key === selectedPeriod.value) || periods[0];
  return getCalculatedMonthly(p.discount / 100);
});

const totalToPay = computed(() => {
  const p = periods.find((p) => p.key === selectedPeriod.value) || periods[0];
  return (finalMonthly.value * p.months).toFixed(2);
});

// SECTION 5: COMPARISON DATA
const compRows = [
  {
    icon: "📦",
    label: "Функционал",
    donut: { type: "good", text: "Всё включено" },
    rival: { type: "bad", text: "Нужны интеграции" },
  },
  {
    icon: "💰",
    label: "Цена",
    donut: { type: "good", text: "от $12" },
    rival: { type: "warning", text: "от $14" },
  },
  {
    icon: "📱",
    label: "Мобильность",
    donut: { type: "good", text: "с телефона" },
    rival: { type: "bad", text: "иногда нужен ноутбук" },
  },
  {
    icon: "🛟",
    label: "Поддержка",
    donut: { type: "good", text: "всегда на связи" },
    rival: { type: "bad", text: "бот и ожидание" },
  },
  {
    icon: "💬️",
    label: "Чат с клиентом",
    donut: { type: "good", text: "через бота" },
    rival: { type: "bad", text: "ограничено или отсутствует" },
  },
  {
    icon: "⚙️",
    label: "Перенос и настройка",
    donut: { type: "good", text: "под ключ" },
    rival: { type: "bad", text: "настраиваете по видео" },
  },
];
</script>

<style scoped>
/* GENERAL BRAND DESIGN TOKENS */
.donut-landing {
  min-height: 100vh;
  font-family:
    "Plus Jakarta Sans",
    "Inter",
    system-ui,
    -apple-system,
    sans-serif;
  color: #1f2937;
  overflow-x: hidden;
  touch-action: manipulation;
}

/* SECTION CONTAINERS */
.section-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* BUTTONS */
.btn-primary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  background-color: #f25c45;
  box-shadow: 0 4px 14px rgb(242 92 69 / 20%);
  transition: all 0.2s;
  cursor: pointer;
}

.btn-primary:hover {
  transform: translateY(-1.5px);
  box-shadow: 0 6px 18px rgb(242 92 69 / 30%);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-secondary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: #1f2937;
  text-decoration: none;
  border: 1px solid #eaecef;
  border-radius: 12px;
  background-color: #f8f9fb;
  transition: all 0.2s;
  cursor: pointer;
}

.btn-secondary:hover {
  transform: translateY(-1.5px);
  color: #f25c45;
  border-color: #f25c45;
  background-color: #ffffff;
}

.btn-lg {
  padding: 14px 28px;
  font-size: 15px;
}

/* SECTION HEADER STYLES */
.section-header {
  display: flex;
  gap: 10px;
  margin-bottom: 32px;
}

.section-header.align-center {
  align-items: center;
}

.section-header.align-left {
  align-items: flex-start;
  text-align: left;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 12px;
  color: #f25c45;
  border: 1px solid #ffd5cf;
  border-radius: 20px;
  background-color: #fff4f2;
}

.badge-icon-svg {
  flex-shrink: 0;
  width: 13px;
  height: 13px;
}

.section-title {
  margin: 0;
  font-weight: 850;
  font-size: 26px;
  color: #1f2937;
  line-height: 1.2;
  letter-spacing: -0.03em;
}

.section-subtitle {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.45;
}

/* SECTION 1: HERO */
.hero-section {
  padding: 30px 0 50px;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 32px;
}

.promo-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  padding: 5px 12px;
  font-weight: 700;
  font-size: 12px;
  color: #f25c45;
  border: 1px solid #ffd5cf;
  border-radius: 20px;
  background-color: #fff4f2;
}

.hero-title {
  margin: 0 0 16px;
  font-weight: 850;
  font-size: 32px;
  color: #1f2937;
  line-height: 1.15;
  letter-spacing: -0.03em;
}

.accent-text {
  color: #f25c45;
}

.hero-subtitle {
  margin: 0 0 24px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

.hero-cta-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 28px;
}

.hero-trust {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-stack {
  display: flex;
}

.avatar-img {
  width: 32px;
  height: 32px;
  border: 2.5px solid #ffffff;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 5px rgb(0 0 0 / 6%);
}

.trust-text {
  display: flex;
  flex-direction: column;
}

.stars-svg-row {
  display: flex;
  gap: 2px;
}

.stars-svg-row.sm .star-svg {
  width: 12px;
  height: 12px;
}

.star-svg {
  width: 14px;
  height: 14px;
  color: #f59e0b;
}

.trust-subtitle {
  margin: 1px 0 0;
  font-size: 11.5px;
  color: #6b7280;
}

/* HERO VISUALS & DUAL PHONES */
.hero-visual {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 420px;
}

.bg-glow {
  position: absolute;
  z-index: 0;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgb(242 92 69 / 6%) 0%, transparent 70%);
  pointer-events: none;
}

/* HERO BANNER & TELEGRAM NOTIFICATIONS */
.banner-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.hero-banner-img {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 15px 35px rgb(0 0 0 / 8%));
}

.tg-notif-card {
  position: absolute;
  z-index: 1;
  transform-origin: top center;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 290px;
  max-width: 85vw;
  padding: 10px 14px;
  opacity: 0;
  border: 1px solid rgb(255 255 255 / 8%);
  border-radius: 18px;
  background: rgb(43 43 46 / 85%);
  backdrop-filter: blur(20px) saturate(190%);
  box-shadow:
    0 10px 30px rgb(0 0 0 / 25%),
    inset 0 0.5px 0 rgb(255 255 255 / 15%);
  pointer-events: none;
}

.tg-notif-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
}

.tg-notif-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  background: #ffffff;
}

.tg-notif-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.tg-notif-badge {
  position: absolute;
  right: -3px;
  bottom: -3px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  border: 1.5px solid rgb(43 43 46 / 85%);
  border-radius: 50%;
  background: #2aabee;
}

.tg-notif-plane {
  width: 8px;
  height: 8px;
  color: #ffffff;
}

.tg-notif-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.tg-notif-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}

.tg-notif-title {
  font-weight: 600;
  font-size: 14.5px;
  color: #ffffff;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.tg-notif-time {
  font-weight: 400;
  font-size: 11.5px;
  color: rgb(255 255 255 / 45%);
  white-space: nowrap;
}

.tg-notif-body {
  font-weight: 400;
  font-size: 13px;
  color: rgb(255 255 255 / 90%);
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* Positions and Animations */
.tg-notif-order {
  top: 70px;
  left: -30px;
  animation: tgNotifFall 0.7s cubic-bezier(0.2, 0.9, 0.3, 1.3) 0.8s forwards;
}

.tg-notif-reminder {
  right: -30px;
  bottom: 80px;
  animation: tgNotifFall 0.7s cubic-bezier(0.2, 0.9, 0.3, 1.3) 1.8s forwards;
}

@keyframes tgNotifFall {
  0% {
    translate: 0 -60px;
    opacity: 0%;
  }

  60% {
    translate: 0 8px;
    opacity: 100%;
  }

  80% {
    translate: 0 -3px;
  }

  100% {
    translate: 0 0;
    opacity: 100%;
  }
}

/* SECTION 2: WHY MYDONUT */
.why-section {
  padding: 50px 0 60px;
  border-top: 1px solid #eaecef;
  background-color: #ffffff;
}

.why-grid-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

/* Vertical slider nav on desktop */
.why-slider-nav-desktop {
  display: none;
}

/* Horizontal tabs on mobile */
.why-tabs-row {
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  width: 100%;
  padding: 4px 4px 12px;
  white-space: break-spaces;
  overflow-x: auto;
}

.why-tabs-row::-webkit-scrollbar {
  display: none;
}

.why-tab-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  padding: 8px 14px;
  border: 1px solid #eaecef;
  border-radius: 12px;
  background: #f8f9fb;
  transition:
    border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  min-width: 110px;
  width: 100%;
}

.why-tab-btn.active {
  border-color: #f25c45;
  background: #fff4f2;
  box-shadow: 0 4px 12px rgb(242 92 69 / 8%);
}

.why-tab-text {
  font-weight: 600;
  font-size: 12px;
  color: #6b7280;
}

.why-tab-btn.active .why-tab-text {
  color: #f25c45;
}

/* Single screenshot container */
.why-image-wrapper-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  touch-action: pan-y;
}

.why-screenshot-wrapper {
  position: relative;
  width: 100%;
  max-width: 440px;
  overflow: hidden;
  margin: 0 auto;
  aspect-ratio: 958 / 978;
}

.why-screenshot-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Vue Transition for screenshot switching */
.why-fade-enter-active,
.why-fade-leave-active {
  transition:
    translate 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    scale 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.why-fade-enter-from {
  translate: 0 10px;
  scale: 0.9;
  opacity: 0%;
}

.why-fade-leave-to {
  translate: 0 -10px;
  scale: 0.9;
  opacity: 0%;
}

/* Active description container (unified) */
.why-active-desc-container {
  width: 100%;
  max-width: 600px;
  margin: -8px auto 8px;
  text-align: center;
}

.why-active-desc-text {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  color: #4b5563;
  line-height: 1.5;
  transition: opacity 0.3s ease;
}

@media (width <= 768px) {
  .why-active-desc-text {
    font-size: 16px;
  }
}

/* Desktop styles */
@media (width >= 769px) {
  .why-grid-layout {
    display: grid;
    grid-template-columns: 1fr 1.1fr;
    align-items: center;
    gap: 48px;
    margin-top: 24px;
  }

  .why-tabs-row {
    display: none;
  }

  .why-active-desc-container {
    display: none;
  }

  .why-slider-nav-desktop {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .why-nav-item {
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    border: 1px solid #eaecef;
    border-radius: 16px;
    background: #f8f9fb;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
  }

  .why-nav-item:hover {
    border-color: #cbd5e1;
    background: #ffffff;
  }

  .why-nav-item.active {
    border-color: #f25c45;
    background: #fff4f2;
    box-shadow: 0 4px 18px rgb(242 92 69 / 6%);
  }

  .why-nav-header-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .why-nav-num {
    font-weight: 800;
    font-size: 12px;
    color: #9ca3af;
  }

  .why-nav-item.active .why-nav-num {
    color: #f25c45;
  }

  .why-nav-title {
    margin: 0;
    font-weight: 800;
    font-size: 15px;
    color: #4b5563;
    transition: color 0.3s ease;
  }

  .why-nav-item.active .why-nav-title {
    color: #1f2937;
  }

  .why-nav-body {
    margin-top: 8px;
    padding-left: 28px;
  }

  .why-nav-text {
    margin: 0;
    font-size: 13.5px;
    color: #6b7280;
    line-height: 1.5;
  }
}

/* Desktop styles */
@media (width >= 992px) {
  .why-screenshot-wrapper {
    width: 100%;
    max-width: 550px;
    height: auto;
  }
}

/* SECTION 3: CLIENT STORIES (TESTIMONIALS) */
.testimonials-section {
  padding: 50px 0 60px;
  border-top: 1px solid #eaecef;
  background-color: #f8f9fb;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #eaecef;
  border-radius: 20px;
  background: #ffffff;
}

.testimonial-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.profile-img-container {
  position: relative;
  flex-shrink: 0;
}

.profile-img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  background: #f3f4f6;
}

.profile-info {
  flex: 1;
  min-width: 0;
}

.profile-name {
  margin-bottom: 1px;
  font-weight: 750;
  font-size: 13.5px;
  color: #1f2937;
}

.profile-role {
  margin-bottom: 3px;
  font-size: 11.5px;
  color: #6b7280;
}

.testimonial-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.testimonial-social-actions {
  display: flex;
  gap: 10px;
}

.btn-social {
  display: inline-flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  font-weight: 700;
  font-size: 16.5px;
  text-decoration: none;
  border-radius: 26px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.social-logo-btn {
  width: 15px;
  height: 15px;
}

.btn-instagram {
  color: #ffffff;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  box-shadow: 0 4px 12px rgb(220 39 67 / 15%);
}

.btn-instagram:hover {
  transform: translateY(-1.5px);
  opacity: 95%;
  box-shadow: 0 6px 18px rgb(220 39 67 / 25%);
}

.btn-telegram {
  color: #ffffff;
  background-color: #2aabee;
  box-shadow: 0 4px 12px rgb(42 171 238 / 15%);
}

.btn-telegram:hover {
  transform: translateY(-1.5px);
  opacity: 95%;
  box-shadow: 0 6px 18px rgb(42 171 238 / 25%);
}

.testimonial-divider {
  height: 1px;
  margin-bottom: 12px;
  background-color: #eaecef;
}

.testimonial-heading {
  margin-top: 8px;
  margin-bottom: 6px;
  font-weight: 750;
  font-size: 14.5px;
  color: #1f2937;
  line-height: 1.3;
}

.testimonial-quote {
  margin: 0;
  font-size: 13px;
  font-style: italic;
  color: #6b7280;
  line-height: 1.5;
}

/* SECTION 4: PRICING */
.pricing-section {
  padding: 50px 0 60px;
  border-top: 1px solid #eaecef;
  background-color: #ffffff;
}

.pricing-grid-layout {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  gap: 24px;
}

.pricing-calculator {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #eaecef;
  border-radius: 20px;
  background-color: #f8f9fb;
}

.calc-inputs-column {
  display: flex;
  flex-direction: column;
}

.total-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.calc-totals-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.total-price-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pricing-cta-btn {
  margin-top: 8px;
}

.calc-parameter-header {
  display: flex;
}

.calc-parameter-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.param-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.param-title {
  font-weight: 500;
  font-size: 13px;
  color: #6b7280;
}

.param-counter {
  font-weight: 850;
  font-size: 18px;
  color: #f25c45;
}

.stepper-control {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #eaecef;
  border-radius: 10px;
  background: #ffffff;
}

.stepper-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  font-weight: 350;
  font-size: 18px;
  color: #1f2937;
  border: none;
  background: transparent;
  cursor: pointer;
}

.stepper-btn:disabled {
  color: #d1d5db;
  cursor: not-allowed;
}

.stepper-btn.btn-plus {
  color: #f25c45;
}

.calc-divider {
  height: 1px;
  margin: 16px 0;
  background-color: #eaecef;
}

/* HORIZONTAL SWIPE GRADES FOR PRICING */
.periods-scroll-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.periods-scroll-row::-webkit-scrollbar {
  display: none;
}

.period-rate-card {
  position: relative;
  display: flex;
  flex: 0 0 110px;
  flex-direction: column;
  justify-content: space-between;
  height: 90px;
  padding: 10px;
  border: 2px solid #eaecef;
  border-radius: 14px;
  background: #ffffff;
  transition: all 0.2s;
  cursor: pointer;
}

.period-rate-card.active {
  border-color: #f25c45;
  background: #fff4f2;
}

.period-discount-badge {
  position: absolute;
  top: -8px;
  right: 8px;
  z-index: 1;
  padding: 1px 5px;
  font-weight: 800;
  font-size: 8px;
  color: #ffffff;
  border-radius: 8px;
  background: #22c55e;
}

.period-title {
  font-weight: 700;
  font-size: 10.5px;
  color: #6b7280;
}

.period-rate-card.active .period-title {
  color: #f25c45;
}

.period-price-details {
  display: flex;
  align-items: baseline;
  margin-top: 4px;
}

.price-val {
  font-weight: 850;
  font-size: 19px;
  color: #1f2937;
}

.price-unit {
  font-size: 11px;
  color: #6b7280;
}

.period-total-val {
  margin-top: auto;
  font-size: 9px;
  color: #6b7280;
}

/* PROMO CODE SWITCH */
.promo-switch-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #eaecef;
  border-radius: 14px;
  background-color: #f8f9fb;
  gap: 8px;
}

.promo-switch-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.promo-switch-title {
  font-weight: 700;
  font-size: 13px;
  color: #1f2937;
}

.promo-switch-desc {
  font-size: 12px;
  color: #6b7280;
}

.switch-control {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 44px;
  height: 24px;
}

.switch-control input {
  width: 0;
  height: 0;
  opacity: 0%;
}

.switch-slider {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 24px;
  background-color: #d1d5db;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.switch-slider::before {
  content: "";
  position: absolute;
  bottom: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgb(0 0 0 / 15%);
  transition: translate 0.2s ease;
}

.switch-control input:checked + .switch-slider {
  background-color: #10b981;
}

.switch-control input:checked + .switch-slider::before {
  translate: 20px 0;
}

.promo-input-group {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.promo-input-field {
  width: 90px;
  padding: 6px 8px;
  font-weight: 700;
  font-size: 11px;
  color: #1f2937;
  text-transform: uppercase;
  border: 1px solid #ffd5cf;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  transition: all 0.2s;
}

.promo-input-field:focus {
  border-color: #f25c45;
  box-shadow: 0 0 0 2px rgb(242 92 69 / 10%);
}

.promo-status-badge {
  padding: 2px 6px;
  font-weight: 800;
  font-size: 10px;
  color: #22c55e;
  white-space: nowrap;
  border: 1px solid #a7f3d0;
  border-radius: 6px;
  background: #ecfdf5;
}

.pricing-cta-block {
  text-align: center;
}

.cta-hint {
  margin: 6px 0 0;
  font-size: 11.5px;
  color: #6b7280;
}

/* SAVINGS HIGHLIGHT CARD (Окупается одной записью) */
.pricing-savings-highlight-card {
  position: relative;
  padding: 24px;
  color: #ffffff;
  overflow: hidden;
  border-radius: 20px;
  background: linear-gradient(135deg, #f25c45 0%, #e04b34 100%);
  box-shadow: 0 10px 24px rgb(242 92 69 / 15%);
}

.decorative-blob {
  position: absolute;
  top: -30px;
  right: -30px;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: rgb(255 255 255 / 6%);
  pointer-events: none;
}

.logo-donut-wrapper {
  margin-bottom: 10px;
}

.donut-svg-white {
  width: 32px;
  height: 32px;
}

.highlight-title {
  margin: 0 0 16px;
  font-weight: 850;
  font-size: 20px;
  color: #ffffff;
  line-height: 1.25;
}

.math-card {
  margin-bottom: 20px;
  padding: 14px;
  border: 1px solid rgb(255 255 255 / 12%);
  border-radius: 14px;
  background: rgb(255 255 255 / 10%);
}

.math-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.math-label {
  font-size: 11.5px;
  color: rgb(255 255 255 / 75%);
}

.math-value {
  font-weight: 700;
  font-size: 13px;
}

.math-divider {
  height: 1px;
  margin: 8px 0;
  background: rgb(255 255 255 / 12%);
}

.total-row {
  margin-bottom: 0;
}

.math-label-strong {
  font-weight: 700;
  font-size: 11.5px;
  color: #ffffff;
}

.math-value-strong {
  font-weight: 850;
  font-size: 16px;
}

.included-features {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-pill {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pill-check-icon {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  color: #ffffff;
  border-radius: 50%;
  background: rgb(255 255 255 / 18%);
}

.pill-text {
  font-size: 12.5px;
  color: rgb(255 255 255 / 90%);
}

/* SECTION 5: COMPARISON */
.comparison-section {
  padding: 50px 0 60px;
  border-top: 1px solid #eaecef;
  background-color: #ffffff;
}

.table-scroll-container {
  width: 100%;
  margin-bottom: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.comparison-table {
  width: 100%;
  text-align: left;
  overflow: hidden;
  border-collapse: collapse;
  border: 1px solid #eaecef;
  border-radius: 16px;
}

th {
  padding: 10px 12px;
  font-size: 12px;
  color: #6b7280;
  background-color: #f8f9fb;
}

td {
  padding: 10px 12px;
  border-top: 1px solid #eaecef;
}

.table-param-header {
  min-width: 120px;
}

.table-donut-header {
  position: relative;
  min-width: 130px;
  padding: 14px 16px;
  color: #ffffff;
  background-color: #f25c45;
}

.donut-header-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.donut-header-svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.donut-title {
  font-weight: 850;
  font-size: 14px;
}

.recommend-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 1.5px 6px;
  font-weight: 700;
  font-size: 8px;
  color: #ffffff;
  border-radius: 8px;
  background: rgb(255 255 255 / 18%);
}

.table-competitor-header {
  min-width: 120px;
  background-color: #f8f9fb;
}

.comp-title {
  font-weight: 700;
  font-size: 12.5px;
  color: #6b7280;
}

.comp-sub {
  display: block;
  margin-top: 1px;
  font-size: 10.5px;
  color: #9ca3af;
}

.cell-param {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 12.5px;
}

.param-icon-wrapper {
  display: flex;
  align-items: center;
  color: #f25c45;
}

.param-icon-wrapper svg {
  width: 14px;
  height: 14px;
}

.cell-donut {
  border-right: 2px solid rgb(242 92 69 / 8%);
  border-left: 2px solid rgb(242 92 69 / 8%);
  background-color: #fff4f2;
}

.badge-status-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.table-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  font-weight: 500;
  font-size: 12px;
  border-radius: 7px;
}

.table-badge-icon {
  display: flex;
  align-items: center;
}

.badge-sub {
  padding-left: 4px;
  font-size: 9.5px;
  color: #6b7280;
}

.comparison-footer {
  margin-top: 20px;
}

.footer-cta-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.footer-migration-note {
  font-size: 11.5px;
  color: #6b7280;
}

.comparison-footnote {
  margin: 0;
  font-size: 10.5px;
  color: #6b7280;
}

/* SECTION 6: FINAL CTA */
.final-cta-section {
  position: relative;
  padding: 40px 0;
  overflow: hidden;
  border-top: 1px solid #eaecef;
  background-color: #ffffff;
}

.cta-bg-glow {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  height: 300px;
  background: radial-gradient(ellipse at top, rgb(242 92 69 / 3%) 0%, transparent 65%);
  pointer-events: none;
}

.cta-grid-layout {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 32px;
}

.cta-info-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: center;
}

.cta-image-col {
  display: flex;
  justify-content: center;
  width: 100%;
}

.cta-mockup-img {
  width: 100%;
  max-width: 480px;
  height: auto;
  border: 1px solid rgb(0 0 0 / 8%);
  border-radius: 16px;
  box-shadow: 0 12px 36px rgb(0 0 0 / 10%);
}

.cta-headline {
  margin: 0;
  font-weight: 850;
  font-size: 26px;
  color: #1f2937;
  line-height: 1.2;
  letter-spacing: -0.03em;
}

.cta-subtitle {
  margin: 0 0 8px;
  font-size: 15px;
  color: #6b7280;
  line-height: 1.5;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.cta-micro-trust {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: #6b7280;
  justify-content: center;
}

.check-circle-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  color: #059669;
  border-radius: 50%;
  background: #d1fae5;
}

/* Trust Avatar Strip at bottom */
.trust-strip-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border: 1px solid #eaecef;
  border-radius: 20px;
  background: #f8f9fb;
}

.avatar-img-large {
  width: 36px;
  height: 36px;
  margin-left: -10px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-img-large:first-child {
  margin-left: 0;
}

.strip-profile-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.strip-title {
  font-weight: 750;
  font-size: 14px;
  color: #1f2937;
}

.strip-subtitle {
  margin-top: 1px;
  font-size: 11.5px;
  color: #6b7280;
}

.strip-stats-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.stat-item-col {
  display: flex;
  flex-direction: column;
}

.stat-val {
  font-weight: 850;
  font-size: 18px;
  color: #f25c45;
}

.stat-lbl {
  margin-top: 1px;
  font-size: 11px;
  color: #6b7280;
}

/* FOOTER SECTION */
.minimal-footer {
  padding: 24px 0;
  border-top: 1px solid #eaecef;
  background-color: #ffffff;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.footer-copy {
  margin: 0;
  font-size: 11.5px;
  color: #9ca3af;
}

.footer-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-link {
  font-size: 12px;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #f25c45;
}

/* ANIMATIONS */
@keyframes slideIn {
  0% {
    transform: translateX(10px);
    opacity: 0%;
  }

  100% {
    transform: translateX(0);
    opacity: 100%;
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(-8px);
    opacity: 0%;
  }

  100% {
    transform: translateY(0);
    opacity: 100%;
  }
}

.animate-fade-in {
  animation: slideIn 0.3s ease-out forwards;
}

/* MEDIA QUERIES (RESPONSIVENESS) */
@media (width >= 480px) {
  .cta-buttons,
  .hero-cta-group {
    flex-direction: row;
  }

  .cta-buttons button,
  .hero-cta-group button,
  .hero-cta-group a {
    flex: 1;
  }
}

/* Mobile-only styles for Section 2 phone stacking & label inline */
.phone-label-inline {
  display: inline-block;
  margin-bottom: 8px;
  text-align: center;
}

.phone-showcase-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.tg-input-field {
  flex: 1;
  padding: 4px 8px;
  font-size: 8px;
  color: #1f2937;
  border: 1px solid #eaecef;
  border-radius: 12px;
  outline: none;
  background: #f8f9fb;
}

.tg-input-field:focus {
  border-color: #2aabee;
}

@media (width <= 768px) {
  .comparison-showcase-inline .comparison-phones {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .comparison-showcase-inline .workflow-arrow-connector {
    transform: rotate(90deg);
    margin: 8px 0;
  }

  .tg-notif-card {
    width: 270px;
    max-width: 80vw;
    padding: 8px 12px;
    border-radius: 14px;
  }

  .tg-notif-title {
    font-size: 13.5px;
  }

  .tg-notif-body {
    font-size: 12.5px;
  }

  .tg-notif-time {
    font-size: 11px;
  }

  .tg-notif-order {
    top: 30px;
    right: auto;
    left: 10px;
  }

  .tg-notif-reminder {
    right: 10px;
    bottom: 30px;
    left: auto;
  }
}

@media (width >= 992px) {
  .testimonials-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (width >= 769px) {
  .section-container {
    padding: 0 32px;
  }

  /* HEADER & NAV */
  .desktop-menu {
    display: flex;
    align-items: center;
    gap: 28px;
  }

  .nav-header {
    height: 70px;
  }

  .nav-container {
    padding: 0 32px;
  }

  /* SECTION HEADERS */
  .section-title {
    font-size: 38px;
  }

  /* HERO */
  .hero-section {
    padding: 70px 0 90px;
  }

  .hero-grid {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  .hero-title {
    font-size: 50px;
  }

  .hero-subtitle {
    max-width: 450px;
    font-size: 17px;
  }

  .hero-cta-group {
    width: fit-content;
  }

  .hero-cta-group button,
  .hero-cta-group a {
    flex: initial;
  }

  .hero-visual {
    height: 500px;
  }

  .tg-notif-card {
    width: 320px;
    padding: 12px 16px;
    border-radius: 20px;
  }

  .tg-notif-avatar-wrapper {
    width: 42px;
    height: 42px;
  }

  .tg-notif-logo {
    width: 26px;
    height: 26px;
  }

  .tg-notif-badge {
    right: -4px;
    bottom: -4px;
    width: 17px;
    height: 17px;
  }

  .tg-notif-plane {
    width: 9px;
    height: 9px;
  }

  .tg-notif-title {
    font-size: 15.5px;
  }

  .tg-notif-time {
    font-size: 12.5px;
  }

  .tg-notif-body {
    font-size: 14px;
  }

  .tg-notif-order {
    top: 0;
    left: -40px;
  }

  .tg-notif-reminder {
    right: -10px;
    bottom: 0;
  }

  /* SECTION 2: WHY DONUT */
  .why-section {
    padding: 70px 0 90px;
  }

  /* SECTION 3: CLIENT STORIES */
  .testimonials-section {
    padding: 70px 0 90px;
  }

  .testimonial-card {
    padding: 24px;
  }

  /* SECTION 4: PRICING */
  .pricing-section {
    padding: 70px 0 90px;
  }

  .pricing-grid-layout {
    grid-template-columns: 1fr 360px;
    gap: 32px;
  }

  .pricing-card-wrapper {
    max-width: 920px;
  }

  .pricing-calculator {
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 32px;
    padding: 32px;
  }

  .calc-inputs-column {
    display: flex;
    flex-direction: column;
  }

  .calc-totals-column {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    padding-left: 32px;
    border-left: 1px solid #eaecef;
  }

  .total-price-wrapper {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: auto;
  }

  .calc-parameter-row {
    margin-bottom: 18px;
  }

  .periods-scroll-row {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .period-rate-card {
    flex: 1 1 0;
  }

  .pricing-savings-highlight-card {
    padding: 32px 28px;
  }

  .highlight-title {
    font-size: 22px;
  }

  .math-card {
    padding: 16px 18px;
  }

  .math-row {
    margin-bottom: 8px;
  }

  .math-divider {
    margin: 10px 0;
  }

  .included-features {
    gap: 10px;
  }

  /* SECTION 5: COMPARISON */
  .comparison-section {
    padding: 70px 0 90px;
  }

  .table-param-header {
    min-width: 180px;
  }

  .table-donut-header {
    min-width: 200px;
  }

  .cell-param {
    font-size: 13.5px;
  }

  .table-badge {
    font-size: 12px;
  }

  .footer-cta-container {
    flex-direction: row;
    align-items: center;
    gap: 20px;
  }

  /* SECTION 6: FINAL CTA */
  .final-cta-section {
    padding: 70px 0 100px;
  }

  .cta-grid-layout {
    grid-template-columns: 1.2fr 1fr;
    gap: 48px;
  }

  .cta-info-col {
    align-items: flex-start;
    text-align: left;
  }

  .cta-headline {
    font-size: 38px;
  }

  .cta-buttons {
    flex-direction: row;
    justify-content: flex-start;
    width: fit-content;
  }

  .cta-buttons button {
    flex: initial;
  }

  .cta-micro-trust {
    justify-content: flex-start;
  }

  .cta-image-col {
    justify-content: flex-end;
  }

  .cta-mockup-img {
    max-width: 100%;
  }

  /* Trust Avatar Strip at bottom */
  .trust-strip-wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
  }

  .strip-stats-block {
    flex-direction: row;
    gap: 32px;
    width: fit-content;
  }

  .strip-text-block {
    text-align: left;
  }

  /* FOOTER */
  .minimal-footer {
    padding: 32px 0;
  }

  .footer-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .footer-left {
    align-items: flex-start;
  }

  .footer-links {
    flex-direction: row;
    gap: 24px;
  }

  /* CASES */
  .testimonials-section.section-cases {
    padding: 70px 0;
  }
  .section-cases__navigation {
    display: none !important;
  }
  .section-cases__slider {
    margin: 0;
    padding: 0;
  }
  .section-cases__slider :deep(.swiper-wrapper) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    transform: none !important;
    width: 100% !important;
  }
  .section-cases__slider :deep(.swiper-slide) {
    width: auto !important;
    height: auto !important;
  }
  .case-slide__image {
    height: 180px;
  }
}

/* CUSTOM SECTION 4 PRICING CALCULATOR CSS */
.product-grades-container {
  width: 100%;
  padding: 12px 8px 32px 8px;
}

.grades-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 24px;
}

.grades-title {
  font-weight: 700;
  font-size: 15px;
  color: #374151;
}

.grades-active-value {
  font-weight: 850;
  font-size: 22px;
  color: #f25c45;
}

.grades-timeline-wrapper {
  position: relative;
  height: 20px;
  margin: 0 10px;
}

.grades-timeline-track {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 6px;
  transform: translateY(-50%);
  background-color: #e5e7eb;
  border-radius: 9999px;
}

.grades-timeline-progress {
  height: 100%;
  background: linear-gradient(90deg, #f25c45 0%, #ff8a75 100%);
  border-radius: 9999px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.grades-points {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}

.grade-point-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  pointer-events: auto;
  user-select: none;
}

.grade-point-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3px solid #d1d5db;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.grade-point-wrapper:hover .grade-point-dot {
  transform: scale(1.25);
  border-color: #f25c45;
}

.grade-point-wrapper.passed .grade-point-dot {
  border-color: #f25c45;
}

.grade-point-wrapper.active .grade-point-dot {
  width: 18px;
  height: 18px;
  background-color: #ffffff;
  border: 5px solid #f25c45;
  box-shadow: 0 0 12px rgba(242, 92, 69, 0.5);
  transform: scale(1.1);
}

.grade-point-label {
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 600;
  font-size: 12px;
  color: #9ca3af;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.grade-point-wrapper.active .grade-point-label {
  color: #1f2937;
  font-weight: 700;
  transform: translate(-50%, -1px);
}

.grade-point-wrapper.passed .grade-point-label {
  color: #4b5563;
}

.pricing-card-wrapper {
  width: 100%;
  margin: 0 auto;
}

.periods-scroll-row-mini {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-bottom: 16px;
}

.period-rate-card-mini {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  border: 1.5px solid #eaecef;
  border-radius: 10px;
  background: #ffffff;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.period-rate-card-mini.active {
  border-color: #f25c45;
  background: #fff4f2;
}

.period-discount-badge-mini {
  position: absolute;
  top: -7px;
  right: 4px;
  z-index: 1;
  padding: 1px 4.5px;
  font-weight: 850;
  font-size: 7.5px;
  color: #ffffff;
  border-radius: 6px;
  background: #22c55e;
}

.period-title-mini {
  font-weight: 750;
  font-size: 11.5px;
  color: #4b5563;
  transition: color 0.2s;
}

.period-rate-card-mini.active .period-title-mini {
  color: #f25c45;
}

/* DETAILED COST BREAKDOWN */
.price-breakdown-box {
  margin-bottom: 18px;
  padding: 14px 16px;
  text-align: left;
  border: 1px solid #eaecef;
  border-radius: 16px;
  background: #ffffff;
}

.breakdown-title {
  margin-bottom: 8px;
  font-weight: 800;
  font-size: 12.5px;
  color: #374151;
}

.breakdown-items-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.breakdown-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
}

.breakdown-label {
  line-height: 1.2;
}

.breakdown-value {
  font-weight: 700;
  color: #1f2937;
}

.breakdown-item-row.discount {
  color: #22c55e;
}

.breakdown-item-row.discount .breakdown-value {
  color: #22c55e;
}

/* TOTAL PRICE SECTION */
.total-price-section {
  text-align: left;
}

.total-header {
  margin-bottom: 4px;
  font-weight: 700;
  font-size: 13px;
  color: #4b5563;
}

.price-display-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.total-big-price {
  font-weight: 900;
  font-size: 32px;
  color: #f25c45;
  line-height: 1;
}

.total-monthly-hint {
  font-weight: 700;
  font-size: 14px;
  color: #6b7280;
}

/* ROI CALLOUT BANNER */
.pricing-roi-callout {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
}

.roi-strong-text {
  font-weight: 850;
  font-size: 13px;
  color: #10b981;
}

/* INCLUDED FEATURES GRID IN CALCULATOR */
.included-features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 18px;
  padding-top: 16px;
  text-align: left;
  border-top: 1px solid #eaecef;
}

@media (width >= 480px) {
  .included-features-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.feature-pill-mini {
  display: flex;
  align-items: center;
  gap: 6px;
}

.feature-pill-mini .pill-check-icon {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  color: #10b981;
  border-radius: 50%;
  background: #ecfdf5;
}

.feature-pill-mini .pill-text {
  font-size: 12px;
  color: #4b5563;
}

/* SECTION 6: CASES SLIDER */
.testimonials-section {
  padding: 50px 0 40px;
  border-top: 1px solid #eaecef;
  background-color: #f8f9fb;
}

.section-cases__navigation {
  display: flex;
  justify-content: flex-end;
  column-gap: 8px;
  margin-top: 16px;
}

.section-cases__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.2s ease;
}

.section-cases__button:hover {
  background-color: #f25c45;
  color: var(--white);
  border-color: #f25c45;
}

.section-cases__button.previous .section-cases__icon {
  transform: rotate(180deg);
}

.section-cases__icon {
  width: 16px;
  height: 16px;
}

.section-cases__slider {
  margin: 0 -20px;
  padding: 0 20px;
}

.section-cases__slider :deep(.swiper-slide) {
  height: auto;
}

.case-slide {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  height: 100%;
  border: 1px solid #eaecef;
  padding: 20px;
}

.case-slide__image {
  width: 100%;
  height: 160px;
  background-color: var(--grey-7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaecef;
  border-radius: 20px;
}

.case-slide__image :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.case-slide__wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  gap: 12px;
  flex: 1;
}

.case-slide__header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.case-slide__badge {
  width: max-content;
  padding: 4px 10px;
  border-radius: 8px;
  background-color: #fff4f2;
  color: #f25c45;
  font-size: 11px;
  font-weight: 700;
}

.case-slide__title {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.3;
  color: var(--grey-1);
  margin: 0;
}

.case-slide__text {
  color: var(--grey-1-5);
  font-size: 13.5px;
  line-height: 1.5;
  flex: 1;
  margin: 0;
}

.case-slide__link {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  margin-top: auto;
}

.btn-sm {
  padding: 8px 14px;
  font-size: 12.5px;
  border-radius: 10px;
}
</style>
